import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class Createsurvey_editchoices extends Plugin {
	init() {
		const editor = this.editor;

		window.addEventListener('load', function () {
			const allParargraphs = document.querySelectorAll('p');
			const lastChild = allParargraphs[allParargraphs.length - 1];
			const styleEl = editorConfig.editchoicesPluginConfig.styles.p.border;
			const pseudoEl = editorConfig.editchoicesPluginConfig.pseudoElementContent;
			lastChild.style.cursor = 'pointer';
			const style = document.createElement('style');
			addBorder(allParargraphs, styleEl, lastChild);

			if (!editorConfig.editchoicesPluginConfig.activePlugin) {
				lastChild.style.display = 'none';
				allParargraphs.forEach(el => {
					el.style.border = 'none';
				})
				return;
			}

			document.head.appendChild(style);
			const sheet = style.sheet;
			sheet.insertRule(pseudoEl, 0);
			const el = document.querySelector('.ck-editor__editable');

			el.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {
					const parent = document.querySelector('.ck-editor__editable_inline');
					const children = parent.children;
					addBorder(children, styleEl, lastChild)
				}
			});

			lastChild.addEventListener('click', function () {
				const positionEl = editor.model.document.selection.getLastPosition().parent;
				editor.execute('insertParagraph', {
					position: editor.model.createPositionBefore(positionEl)
				});

				const allParargraphs = document.querySelectorAll('p')
				addBorder(allParargraphs, styleEl, lastChild)
			});
		});
	}
}

export const editorConfig = {
	plugins: [Createsurvey_editchoices],
	editchoicesPluginConfig: {
		activePlugin: true,
		styles: {
			'p': {
				border: '1px solid #e0e0e0',
			}
		},
		pseudoElementContent:
			'.class-pseudo::before { content: "Enter answer please!"; }'
	},
};

function addBorder(items, style, lastEl) {
	lastEl.classList.add('last-el', 'class-pseudo');
	for (let i = 0; i < items.length; i++) {
		items[i].style.border = style;
	}
}


// export default class CreatesurveyEditchoices extends Plugin {
// 	init() {
// 		  const editor = this.editor;
// 		//  const pluginConfig = editor.config.get('editchoicesPluginConfig');
// 		window.addEventListener('load', function () {
// 			console.log(editorConfig.editchoicesPluginConfig)
// 			const allParargraphs = document.querySelectorAll('p');
// 			const lastChild = allParargraphs[allParargraphs.length - 1];
// 			const styleEl = editorConfig.editchoicesPluginConfig.styles.p.border;
// 			console.log(styleEl)
// 			// const styleEl = pluginConfig.styles.p.border;
// 			// const pseudoEl = pluginConfig.pseudoElementContent;
// 			// const style = document.createElement('style');

// 			// if (!pluginConfig || !pluginConfig.activePlugin) {
// 			// 	lastChild.style.display = 'none';
// 			// 	return;
// 			// }
// 			// 		document.head.appendChild(style);
// 			// 		const sheet = style.sheet;
// 			// 		sheet.insertRule(pseudoEl, 0);
// 			// 		const el = document.querySelector('.ck-editor__editable');
// 			// el.addEventListener('keydown', function (event) {
// 			// 	if (event.key === 'Enter') {
// 			// 		const parent = document.querySelector('.ck-editor__editable_inline');
// 			// 		const children = parent.children;
// 			// 		addBorder(children, styleEl, lastChild)
// 			// 	}
// 			// 		});
// 			// 		addBorder(allParargraphs, styleEl, lastChild)
// 			lastChild.addEventListener('click', function () {
// 				const positionEl = editor.model.document.selection.getLastPosition().parent;
// 				editor.execute('insertParagraph', {
// 				position: editor.model.createPositionBefore(positionEl)
// 				});
// 				const allParargraphs = document.querySelectorAll('p')
// 				addBorder(allParargraphs, styleEl, lastChild)
// 			});
// 		});
// 	}
// }
